<h1>Contact Us</h1>
<mat-card appearance="outlined" class="sharp global">
    <mat-card-content>
        <h2>General Inquiries</h2>
        <p>Email: <a href="mailto:customer.care@lawsociety.ab.ca">customer.care&#64;lawsociety.ab.ca</a></p>
        <p>Tel: 403.229.4700<br>
        Toll-free: 1.800.661.9003</p>
        <div class="box-officehrs">
            <h2>Office hours: Mon - Fri 8 a.m. - 4:30 p.m.</h2>
            <p>Toll-free numbers valid only in Alberta, Saskatchewan, Lower Mainland British Columbia, Yukon, Northwest Territories and Nunavut.</p>
            <p>The Law Society of Alberta is closed on all statutory and civic holidays, including the National Day for Truth and Reconciliation (Sept.30).</p>
        </div>
        <p>For all other inquiries visit: <a rel="noopener" href="https://www.lawsociety.ab.ca/about-us/contact-us/" target="_blank">lawsociety.ab.ca/about-us/contact-us/</a></p>
    </mat-card-content>
</mat-card>
